/* eslint-disable react-refresh/only-export-components */
import { lazy } from 'react'
import { Route } from 'react-router-dom'
import { RequireAuth } from '@/app/router/RequireAuth'

const PlayersPage = lazy(() => import('@/pages/players/Page').then((m) => ({ default: m.PlayersPage })))
const PlayersAllPage = lazy(() => import('@/pages/players/all/Page').then((m) => ({ default: m.PlayersAllPage })))
const PlayerViewPage = lazy(() => import('@/pages/players/view/Page').then((m) => ({ default: m.PlayerViewPage })))
const PlayerNewPage = lazy(() => import('@/pages/players/new/Page').then((m) => ({ default: m.PlayerNewPage })))
const PlayerEditPage = lazy(() => import('@/pages/players/edit/Page').then((m) => ({ default: m.PlayerEditPage })))

export function playerRoutes() {
  return (
    <>
      <Route path="/players" element={<PlayersPage />} />
      <Route path="/players/all" element={<PlayersAllPage />} />
      <Route
        path="/players/new"
        element={
          <RequireAuth>
            <PlayerNewPage />
          </RequireAuth>
        }
      />
      <Route
        path="/players/edit/:playerId"
        element={
          <RequireAuth>
            <PlayerEditPage />
          </RequireAuth>
        }
      />
      <Route path="/players/:shortId/:slug?" element={<PlayerViewPage />} />
    </>
  )
}
